import React from "react";
import { Select, Button } from "antd";
import { useSelector } from "react-redux";

const { Option } = Select;

export const FilterXmlZipFile = ({
  handleSubmit,
  setFormData,
  formData,
  disableSubmitButton,
}) => {
  const isFormValid = formData.cycleNo;
  const { uploadXmlZipFile } = useSelector((state) => {
    return {
      uploadXmlZipFile: state.uploadXmlZipFileReducer,
    };
  });

  return (
    <div className="flex items-center justify-end gap-4 px-4 py-2">
      <Select
        suffixIcon={<span className="text-lg font-bold text-red-500">*</span>}
        placeholder="Select Cycle No."
        className="w-48"
        onChange={(value) => setFormData({ ...formData, cycleNo: value })}
      >
        {[...Array(8)].map((_, i) => (
          <Option key={i} value={i + 1}>
            Cycle {i + 1}
          </Option>
        ))}
      </Select>
      {uploadXmlZipFile?.loading === false &&
      uploadXmlZipFile?.data === null &&
      uploadXmlZipFile?.error === null ? (
        <Button
          type="primary"
          onClick={handleSubmit}
          className={`bg-blue-500 text-white hover:bg-blue-600`}
          disabled={!isFormValid || disableSubmitButton}
        >
          Submit
        </Button>
      ) : (
        <>
          {uploadXmlZipFile?.loading === true && (
            <span className="animate-pulse text-lg text-yellow-600">
              File uploading...
            </span>
          )}
          {uploadXmlZipFile?.loading === false &&
            uploadXmlZipFile?.error !== null && (
              <span className="text-lg text-red-600">
                {uploadXmlZipFile?.error?.response?.message ||
                  uploadXmlZipFile?.error?.response ||
                  uploadXmlZipFile?.error}
              </span>
            )}
          {uploadXmlZipFile?.loading === false &&
            uploadXmlZipFile?.data !== null && (
              <span className="text-lg text-green-600">
                File uploaded successfully
              </span>
            )}
        </>
      )}
    </div>
  );
};
